export default function(locale = "en-US", length = "long") {
    let today = new Date();
    let workDate = new Date(today.setDate(1));
    let result = [];
    for (let i = 0; i < 12; i++) {
        workDate.setMonth(i);
        result.push(workDate.toLocaleDateString(locale, { month: length }));
    }

    return result;
}
